import {faExclamationCircle} from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';

import {Icon} from '../Icon/Icon';
import {Popover, PopoverContent, PopoverTrigger} from '../Popover';

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  name: string;
  value: string;
  error?: string;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveValue: () => void;
};
export function MultiTextInput({
  error,
  disabled,
  className,
  onRemoveValue,
  ...props
}: Props): React.JSX.Element {
  return (
    <div className="flex">
      <div className="-mr-px grid grow grid-cols-1 focus-within:relative">
        <input
          {...props}
          id={props.name}
          className={clsx(
            'col-start-1 row-start-1 block w-full rounded-l-md border-0 bg-slate1 px-3 py-1.5 text-base text-slate12 shadow-xs outline-solid outline-1 -outline-offset-1 outline-slate7 focus:ring-0 focus-visible:relative focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-blue8 disabled:bg-slate3 sm:text-sm/6',
            error
              ? 'outline-tomato7 focus-visible:outline-tomato8 sm:pr-9'
              : 'outline-slate7 focus-visible:outline-blue8'
          )}
        />
        {!!error && (
          <Popover>
            <PopoverTrigger asChild>
              <Icon
                icon={faExclamationCircle}
                className={clsx(
                  error && 'text-tomato11',
                  'col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end sm:size-4'
                )}
              />
            </PopoverTrigger>
            <PopoverContent>{error}</PopoverContent>
          </Popover>
        )}
      </div>
      <button
        type="button"
        onClick={onRemoveValue}
        disabled={disabled}
        className="hocus:relative hocus:outline-2 hocus:-outline-offset-2 hocus:outline-tomato8 disabled:hocus:outline-1 disabled:hocus:-outline-offset-1 disabled:hocus:outline-slate7 flex shrink-0 items-center gap-x-1.5 rounded-r-md bg-slate1 px-3 py-2 text-sm font-semibold text-tomato11 outline-solid outline-1 -outline-offset-1 outline-slate7 disabled:bg-slate3 disabled:text-slate11"
      >
        Remove
      </button>
    </div>
  );
}
